import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputHelpComponent } from './input-help.component';
import { ButtonModule } from '@shared/button';

@NgModule({
  declarations: [InputHelpComponent],
  imports: [CommonModule, ButtonModule],
  exports: [InputHelpComponent],
})
export class InputHelpModule {}
